module.exports = __webpack_public_path__ + "img/ViceGouv_Logo-black.e3627af1.png";